import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Configuration } from '../../../lead-generation/shared/domain/configuration.model';
import { FormArray, FormGroup } from '@angular/forms';

@Component({
  selector: 'cc-ivr-actions',
  templateUrl: './ivr-actions.component.html',
  styleUrls: ['./ivr-actions.component.scss']
})
export class IvrActionsComponent {
  @Input() ivrActionsFormWrapper: FormGroup;
  @Input() configuration: Configuration;
  _msisdns: any[];
  @Input() set msisdns(msisdns: any[]) {
    this._msisdns =  msisdns.filter(number => !!number.msisdn && !number.msisdn.includes('webcall'));
  }
  @Output() removeIvrAction = new EventEmitter();

  removeAt(index) {
    this.removeIvrAction.next(index);
  }

  get form() {
    return (this.ivrActionsFormWrapper.get('menus.0') as FormArray).get('menuEntries') as FormGroup;
  }


  selectedMsisdn(msisdn: string) {
    return this.msisdns.find(number => number.msisdn === msisdn);
  }
}
